<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">请假记录</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <template>
                    <el-table
                        :data="tableData"
                        border
                        ref="LevelTable"
                        v-loading="loading"
                        style="width: 100%" :height="th+100">
                        <el-table-column prop="elderlyName"  label="老人姓名"></el-table-column>
                        <el-table-column prop="startTime"  :formatter="formatterTime" label="开始时间" width="180"></el-table-column>
                        <el-table-column prop="endTime" :formatter="formatterTime" label="预计返回时间" width="180"> </el-table-column>
                        <el-table-column prop="reportTime" :formatter="formatterTime" label="销假时间" width="180"> </el-table-column>
                        <el-table-column prop="dayNumber"  label="请假天数"> </el-table-column>
                        <el-table-column prop="bailorName" label="委托人姓名"></el-table-column>
                        <el-table-column prop="bailorPhone" label="委托人电话" width="120"></el-table-column>
                        <el-table-column prop="remarks" label="请假原因"> </el-table-column>
                        <el-table-column fixed="right" label="操作" width="160">
                            <template slot-scope="scope">
                                <!-- <el-button type="primary" v-if="scope.row.isReport==0" @click="reportClick(scope.row)">销假</el-button> -->
                                <el-button type="danger" size="small" v-if="scope.row.isReport==1 && scope.row.isRefund ==1" @click="reportDetailClick(scope.row)">退费详情</el-button>
                                <el-button type="info" v-else size="small">无</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <el-dialog title="退费详情" :visible.sync="dialogVisible" :modal-append-to-body='false'>
                    <div style="padding:15px 10px;">
                        <span>审核情况：</span>
                        <span v-if="isCheck==0">未审核</span>
                        <span v-if="isCheck==1">已通过</span>
                        <span v-if="isCheck==2">未通过</span>
                    </div>
                    <div style="padding:15px 10px;">
                        <span>请假天数：{{dayNumber}}</span>
                    </div>
                    <el-table :data="gridData">
                        <el-table-column property="refundType" label="退费类型" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.refundType=='room'">床位退费</span>
                                <span v-if="scope.row.refundType=='nursing'">护理退费</span>
                                <span v-if="scope.row.refundType=='other'">其它退费</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="refundMoney" label="退款金额(元)" width="200"></el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- <Report ref="myReport" v-show="showModalReport" v-on:closeReport="showModalReport=false" v-on:getRecord="getRecord"></Report> -->
        </div>
        
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    // import Report from "./Report";


    export default {
        name: 'Add',
        props:['dishesList'],
        data() {
            return {
                buttonLoading:false,
                loading: true,
                showReport:true,
                row:null,
                showModalReport:false,
                dialogVisible: false,
                gridData:null,
                isCheck:0,
                dayNumber:0,
                th:this.$store.state.tableHeight
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        components:{
            // Report
        },
        methods: {
            init(row){
                // this.$refs.addForm.resetFields();
                this.row = row;
                // this.addForm.elderlyCode = row.elderlyCode;
                this.getRecord();
                // this.addForm.checkinCode = row.checkinList[0].checkinCode;
            },
            //销假详情
            reportDetailClick(value) {
               this.isCheck = value.isCheck;
               this.dayNumber = value.dayNumber;
               this.gridData = value.refundSettleItemList;
               this.dialogVisible=true;
            },
            // //销假
            // reportClick(value){
            //     console.log(value);
            //     this.showModalReport = !this.showModalReport;
            //     this.$refs.myReport.init(value);
            // },
            getRecord(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundSettle/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyCode:this.row.elderlyCode,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data;
                        if(response.data.data.length>0 && response.data.data[0].isReport==0){
                            this.showReport = false;
                        }else{
                            this.showReport = true;
                        }
                        this.$nextTick(()=>{
                            this.$refs.LevelTable.doLayout()
                        })
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            closeSelf() {
                this.$emit("closeLeave");
            },
        }
    }


</script>





<style lang="scss" scoped>

   .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
